import { render, staticRenderFns } from "./V2OrderActions.vue?vue&type=template&id=5903cd51&scoped=true&"
import script from "./V2OrderActions.vue?vue&type=script&lang=js&"
export * from "./V2OrderActions.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderActions.vue?vue&type=style&index=0&id=5903cd51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903cd51",
  null
  
)

export default component.exports